var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[(Object.keys(_vm.getStates).length > 1)?_c('tab-onglet'):_c('v-row',{staticClass:"fill-height",attrs:{"align":"start","justify":"center","no-gutters":""}},[(_vm.currentComponent)?_c(_vm.currentComponent,{tag:"component"}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }